<template>
  <q-checkbox
    ref="checkboxRef"
    v-model="value"
    class="san-field--checkbox"
    indeterminate-value="maybe"
    dense
    @update:model-value="handleChange"
  />
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useField } from 'vee-validate'

defineOptions({ name: 'SanFieldCheckbox' })
const value = defineModel({ type: Boolean, default: false })
const props = defineProps({
  name: { type: String, required: true }
})

const checkboxRef = ref(null)

const { handleChange } = useField(() => props.name, undefined, {
  type: 'checkbox',
  checkedValue: value
})

onMounted(() => {
  const svg = checkboxRef.value.$el.querySelector('svg')
  for (const path of svg.querySelectorAll('path')) {
    path.parentNode.removeChild(path)
  }
})
</script>
